import React from "react";
import SidebarNavItem from "./SidebarNavItem";
import { getCategoryKey, getPageFeatures } from "../utils/legalSidebar";

export default function SidebarOverview({
  category,
  activeKey,
  transactionsToApproveCount,
  onNavigate,
}) {
  if (!category) return null;

  const items = (Array.isArray(category?.Sections) ? category.Sections : []).flatMap(
    (section) => getPageFeatures(section),
  );

  if (!items.length) return null;

  return (
    <section className="new-sidebar-overview">
      <div className="new-sidebar-overview__title">
        {category?.Description || "Overview"}
      </div>
      <div className="new-sidebar-overview__items">
        {items.map((feature) => {
          const slug = feature?.Slug || "";
          const label = feature?.Description || slug;
          const isMakePayment = slug.toLowerCase() === "makepayment";
          const count =
            slug.toLowerCase() === "pendingapprovals"
              ? transactionsToApproveCount
              : undefined;

          return (
            <SidebarNavItem
              key={`${getCategoryKey(category)}-${feature?.FeatureID ?? slug}`}
              label={label}
              count={count}
              active={activeKey === slug}
              overview
              action={isMakePayment}
              onClick={() => onNavigate(slug, slug)}
            />
          );
        })}
      </div>
    </section>
  );
}
